import * as Sentry from '@sentry/browser';
import { SeverityLevel } from '@sentry/types';
import { SentrySeverityLevels } from 'src/utils/SentrySeverity';

export const captureException = async (err) => {
  try {
    Sentry.withScope((scope) => {
      scope.setLevel(SentrySeverityLevels.Error as SeverityLevel);
      Sentry.captureException(err);
    });
  } catch (err: any) {
    console.error(`Unable to track error in Sentry. Error: ${err.message}`, { error: err }); // eslint-disable-line no-console
  }
};

export default {
  captureException
};
